import styled from 'styled-components';
import { useRef } from 'react';
import withErrorBoundary from '../ErrorBoundary';
import { FEATURE_TABLE } from '../_core/common/constants/ErrorBoundaryNames';
import { tracker } from '../_core/common/eventTracking/tracker';
import { useIntersectionObserver } from '../_core/common/hooks/useIntersectionObserver';
import ExpandableSection from './ExpandableSection';
import FeatureTableHead from './FeatureTableHead';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TableContainer = styled.div.withConfig({
  displayName: "FeatureTable__TableContainer",
  componentId: "sc-1pg3soh-0"
})(["width:100%;"]);
export const Table = styled.table.withConfig({
  displayName: "FeatureTable__Table",
  componentId: "sc-1pg3soh-1"
})(({
  theme
}) => ({
  width: '100%',
  borderSpacing: theme.borderWidth['0'],
  tableLayout: 'fixed'
}));
const FeatureTable = ({
  headerData,
  bodyData,
  canViewNewSeats,
  onExpand,
  onCollapse,
  defaultNumberOfRowsToShow
}) => {
  const sections = Object.keys(bodyData.sectionData);
  let numColumns = 0;
  sections.forEach(section => {
    if (bodyData.sectionData[section].apiNames.length > numColumns) {
      numColumns = bodyData.sectionData[section].apiNames.length;
    }
  });
  const featureTableRef = useRef(null);
  useIntersectionObserver({
    onIntersect: () => {
      tracker.track('featureTableInteraction', {
        action: 'scrolled-in-view',
        screen: bodyData.sharedData.subscreen
      });
    },
    targetRef: featureTableRef
  });
  return /*#__PURE__*/_jsx(TableContainer, {
    "data-test-id": "feature-table",
    id: "feature-table",
    ref: featureTableRef,
    children: /*#__PURE__*/_jsxs(Table, {
      children: [/*#__PURE__*/_jsx(FeatureTableHead, {
        headerData: headerData
      }), sections.map(section => {
        return /*#__PURE__*/_jsx(ExpandableSection, {
          featureTableCategory: bodyData.sectionData[section],
          tableSharedData: bodyData.sharedData,
          id: section,
          showLabel: sections.length > 1,
          canViewNewSeats: canViewNewSeats,
          onExpand: onExpand,
          onCollapse: onCollapse,
          defaultNumberOfRowsToShow: defaultNumberOfRowsToShow
        }, section);
      })]
    })
  });
};
export default withErrorBoundary(FeatureTable, {
  boundaryName: FEATURE_TABLE
});